export const symbols_map = {
    EUR: '€',
    PLN: 'zł',
    CHF: 'CHF',
    UAH: '₴',
    CAD: '$',
    ARS: '$',
    MXN: '$',
    GBP: '£',
    PEN: 'S/',
    USD: '$',
    BOB: 'Bs.',
    BRL: 'R$',
    CLP: '$',
    COP: '$',
    PYG: '₲',
    UYU: '$U',
    VES: 'Bs.S',
    DOP: 'RD$',
    CRC: '₡'
}
const isKnownCurrency = (
    school_currency: string
): school_currency is keyof typeof symbols_map => school_currency in symbols_map
export const currencySymbol = (school_currency: string) =>
    isKnownCurrency(school_currency) ? symbols_map[school_currency] : ''
